
// import CryptoJS from './crypto-js.js'
import CryptoJS from 'crypto-js/crypto-js'

const keys = 'gdklzbwxgongzhonghao'; // 大良自己的密钥,前后端一致

export default {
  formatDate (value) {
    let date = new Date(parseInt(value))
    let y = date.getFullYear()
    let MM = date.getMonth() + 1
    MM = MM < 10 ? ('0' + MM) : MM
    let d = date.getDate()
    d = d < 10 ? ('0' + d) : d
    let h = date.getHours()
    h = h < 10 ? ('0' + h) : h
    let m = date.getMinutes()
    m = m < 10 ? ('0' + m) : m
    let s = date.getSeconds()
    s = s < 10 ? ('0' + s) : s
    return y + '-' + MM + '-' + d
  },
  Hash_encrypt (word) {
    var encrypted = CryptoJS.HmacSHA256(word, keys)
    var hashInBase64 = CryptoJS.enc.Base64.stringify(encrypted)
    return hashInBase64.toString()
  },

  MD5 (word) {
    return CryptoJS.MD5(word).toString()
  }
}



// WEBPACK FOOTER //
// ./src/utils/request/utils.js